import { Box, Card, CardContent, CardProps } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { infoCardStatus } from 'components/CreateSpark/SparkBuilderCanvas/ChartComponents/statusConfigByStatusTag';
import SparkEllipsisTypography from './SparkEllipsisTypography';

type InfoCardProps = {
  info: React.ReactNode;
  cardStyles?: CardProps['sx'];
  type?: 'warning' | 'error' | 'info' | 'success';
  customIcon?: React.ReactElement | null;
  infoStyles?: CardProps['sx'];
  children?: React.ReactNode;
  iconSize?: 'small' | 'inherit' | 'medium' | 'large';
};
const InfoCard = ({
  info,
  cardStyles,
  type = 'info',
  customIcon,
  infoStyles,
  iconSize = 'medium',
  children,
}: InfoCardProps) => {
  const config = infoCardStatus?.[type];
  const isInfoCard = type === 'info';
  const Icon = config?.Icon || <></>;

  const sizeMap = {
    small: '15',
    inherit: '20',
    medium: '25',
    large: '50',
  };

  return (
    <Card
      sx={{
        display: 'flex',
        alignItems: 'center',
        boxShadow: 'none',
        backgroundColor: config.bgColor,
        maxHeight: '2.5rem',
        ...cardStyles,
      }}
      style={{
        borderRadius: '10px',
        border: `1px solid ${config.borderColor}`,
      }}
    >
      <CardContent
        sx={{
          position: 'relative',
          p: 0,
          width: '100%',
          paddingBottom: '0px !important',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            p: 1.5,
            gap: 1,
            ...infoStyles,
          }}
        >
          {customIcon ? (
            customIcon
          ) : isInfoCard ? (
            <InfoIcon htmlColor='var( --color-primary)' fontSize={iconSize} />
          ) : (
            <Icon
              width={sizeMap[iconSize]}
              height={sizeMap[iconSize]}
              fontSize={iconSize}
            />
          )}
          <SparkEllipsisTypography
            variant='subtitle2'
            sx={{
              WebkitLineClamp: 1,
              width: '100%',
              textWrap: 'pretty',
              marginTop: 0.4,
            }}
          >
            {info}
          </SparkEllipsisTypography>
          {children && <Box>{children}</Box>}
        </Box>
      </CardContent>
    </Card>
  );
};
export default InfoCard;
